module.exports = __webpack_public_path__ + "static/img/logo.ecd9b878.png";